export default __webpack_public_path__ + "static/media/dashboard-connected-distributors.81d39ed3.svg";